import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Badge,
  Tooltip,
} from "reactstrap";
import classnames from "classnames";
import { getCustomerUserId } from "../../common/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserDetails } from "../../../redux/actions";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import MyDog from "./MyDog";
import Transaction from "./Transaction";
import Licence from "./Licence";
import userlogo from "../../../images/user logo.png";
import UserSettings from "../Settings/UserSettings";
import HeaderLogo from "../../common/HeaderLogo";
import { Info } from "../../common/Info";
import { AGENCY_IDLOGO_URL } from "../../../constants/ApiPaths";
import {
  CUSTOMER_AGENCY_URL,
  TTID,
} from "../../../constants/LocalStorageVariables";
import API from "../../../redux/actions/API";
import {
  AGENCY_DELETE,
  DOG_PLAN_DETAILS_RESET,
} from "../../../redux/actions/ActionTypes";

function UserDashBoard(props) {
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();
  const [id, setid] = useState("");

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [pageloading, setpageloading] = useState(true);
  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    createdDate: "",
    email: "",
    gender: "",
    phoneNumber: "",
    profileImage: "",
    stateName: "",
    zip: "",
    totalLicense: "",
    totalPaidAmount: 0,
  });
  useEffect(() => {
    dispatch(getLoggedUserDetails(getCustomerUserId()));
  }, []);
  const reduxState = useSelector((state) => state.AuthUserDetailsReducer);
  useEffect(() => {
    setFormData({ ...reduxState });
  }, [reduxState]);
  useEffect(() => {
    dispatch({
      type: DOG_PLAN_DETAILS_RESET,
      payload: "",
    });
  });
  const getAgencyIdandLogo = async () => {
    const agencyUrl = localStorage.getItem(CUSTOMER_AGENCY_URL);
    setpageloading(true);
    const config = {
      method: "GET",
      url: AGENCY_IDLOGO_URL,
      params: { agencyUrl: agencyUrl },
    };
    try {
      const response = await API(config);
      const { status, isDeleted,  agencyId, agencyLogo, ttid } =
        response.data;

      localStorage.setItem("LOGGED_AGENCY_ID", agencyId);
      localStorage.setItem("AGENCYLOGO", agencyLogo);
      localStorage.setItem(TTID, ttid);

      if (status === "Success") {
        localStorage.setItem("DELETED_AGENCY", isDeleted);

        dispatch({
          type: AGENCY_DELETE,
          payload: isDeleted,
        });
      }
    } catch (error) {
      console.error(error);
      // history("/*");
    } finally {
      setpageloading(false);
    }
  };

  useEffect(() => {
    getAgencyIdandLogo();
  }, []);

  setInterval(() => {
    setpageloading(false);
  }, 3000);

  return (
    <div>
      <HeaderLogo />

      <Container fluid>
        <Row className="mt-4">
          <Col xl="5">
            <Row>
              <Col md="12">
                {pageloading && <CustomPageLoading />}
                <Card body>
                  <div className="customer-name">
                    <img
                    alt=""
                      src={
                        formData.profileImage ? formData.profileImage : userlogo
                      }
                    />

                    <div className="name">
                      <h4>
                        {formData.firstName} {formData.lastName}
                      </h4>
                      <Badge color="primary">{formData.email}</Badge>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col md="12">
                <Card body>
                  <div className="customer-personal-info">
                    <Row>
                      <Col md="6">
                        <div className="info">
                          <span>FIRST NAME</span>
                          <p>
                            {formData.firstName ? formData.firstName : "N/A"}
                          </p>
                        </div>

                        <div className="info">
                          <span>EMAIL</span>
                          <p>{formData.email ? formData.email : "N/A"}</p>
                        </div>

                        <div className="info">
                          <span>GENDER</span>
                          <p>{formData.gender ? formData.gender : "N/A"}</p>
                        </div>

                        <div className="info">
                          <span>ADDRESS</span>
                          <p>{formData.address ? formData.address : "N/A"}</p>
                        </div>

                        <div className="info">
                          <span>STATE</span>
                          <p>
                            {formData.stateName ? formData.stateName : "N/A"}
                          </p>
                        </div>

                        {/* <div className="info">
                          <span>CREATED DATE</span>
                          <p>
                            {formData.createdDate
                              ? moment(formData.createdDate).format(
                                  "MM/DD/YYYY"
                                )
                              : "N/A"}
                          </p>
                        </div> */}
                      </Col>
                      <Col md="6">
                        <div className="info">
                          <span>LAST NAME</span>
                          <p>{formData.lastName ? formData.lastName : "N/A"}</p>
                        </div>
                        <div className="info">
                          <span>PHONE</span>
                          <p>
                            {formData.phoneNumber
                              ? formData.phoneNumber
                              : "N/A"}
                          </p>
                        </div>
                        {/* <div className="info">
                          <span>DOB</span>
                          <p>
                            <p>
                              {(formData.dateOfBirth == "01/01/1900"
                                ? "N/A"
                                : formData.dateOfBirth) || "N/A"}
                            </p>
                          </p>
                        </div> */}
                        <div className="info">
                          <span>CITY</span>
                          <p>{formData.city ? formData.city : "N/A"}</p>
                        </div>
                        <div className="info">
                          <span>ZIP</span>
                          <p>{formData.zip ? formData.zip : "N/A"}</p>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-6">
                      <Col sm="6" className="user-dash-count border-right">
                        <div className="bg">
                          <p>Total License</p>
                          <div className="count">
                            <h4>{formData.totalLicense || 0}</h4>
                          </div>
                        </div>
                      </Col>
                      <Col sm="5" className="user-dash-count">
                        <div className="bg">
                          <p>Total Paid Amount</p>
                          <div className="count">
                            <h4>
                              {parseFloat(
                                formData.totalPaidAmount || 0
                              ).toFixed(2)}
                              $
                            </h4>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Col>
              <Col md="12"></Col>
            </Row>
          </Col>

          <Col xl="7">
            <div>
              <Nav tabs className="mt-lg-4">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    My Pets
                    <Tooltip
                      isOpen={id === "mypets" && tooltipOpen}
                      target={"mypets"}
                      toggle={() => tooltiptoggle("mypets")}
                    >
                      List of registered pets
                    </Tooltip>
                    <span id={"mypets"}>
                      <Info />
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    License
                    <Tooltip
                      isOpen={id === "license" && tooltipOpen}
                      target={"license"}
                      toggle={() => tooltiptoggle("license")}
                    >
                      Customer license information
                    </Tooltip>
                    <span id={"license"}>
                      <Info />
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggle("3");
                    }}
                  >
                    Transaction
                    <Tooltip
                      isOpen={id === "transactio" && tooltipOpen}
                      target={"transactio"}
                      toggle={() => tooltiptoggle("transactio")}
                    >
                      Customer transaction history
                    </Tooltip>
                    <span id={"transactio"}>
                      <Info />
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "4" })}
                    onClick={() => {
                      toggle("4");
                    }}
                  >
                    Settings
                    <Tooltip
                      isOpen={id === "settings" && tooltipOpen}
                      target={"settings"}
                      toggle={() => tooltiptoggle("settings")}
                    >
                      Customer account settings
                    </Tooltip>
                    <span id={"settings"}>
                      <Info />
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="2">
                  <Licence />
                </TabPane>

                <TabPane tabId="1">
                  <MyDog />
                </TabPane>
                <TabPane tabId="3">
                  <Transaction />
                </TabPane>
                <TabPane tabId="4">
                  <UserSettings />
                </TabPane>
              </TabContent>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default UserDashBoard;
